<template>
  <v-btn :disabled="disabled" icon x-small @click="copyText()">
    <v-icon :size="iconSize" :color="copyState">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>


<script>
const copyStates = Object.freeze({
  none: null,
  success: 'success',
  error: 'error',
});

export default {
  name: "CopyToClipBoardBtn",
  props: {
    text: String,
    size: {
      type: Number,
      default: 15,
    },
    disabled: Boolean,
  },
  components: {},
  mixins: [],

  data() {
    return {
      copyState: copyStates.none,
    };
  },

  methods: {
    copyText() {
      navigator.clipboard.writeText(this.text)
        .then(() => {
          this.setFadingState(copyStates.success);
          //console.log('Content copied to clipboard');
        })
        .catch(e => {
          this.setFadingState(copyStates.error);
          console.error('Failed to copy', e);
        });
    },

    setFadingState(state) {
      this.copyState = state;
      setTimeout(() => {
        this.copyState = copyStates.none;
      }, 1000);
    },
  },

  computed: {
    iconSize() {
      //smaller icon during other copy states
      return this.copyState == copyStates.none ? this.size :(this.size * 0.9) ;
    },

    icon() {
      if (this.copyState == copyStates.error) {
        return 'mdi-close'
      }
      else if (this.copyState == copyStates.success) {
        return 'mdi-check'
      }
      else {
        return 'mdi-content-copy'
      }
    },
  },

  watch: {},
};
</script>


<style scoped></style>
